module.exports = __webpack_public_path__ + "img/technology-18.05e94f8c.png";